import React from "react";
import Modal from "@material-ui/core/Modal";
import Button from "@material-ui/core/Button";
import "../styles/modalStyles.css";

const NotificationModal = (props) => {
  const { title, isOpen, onClose } = props;

  return (
    <Modal open={isOpen} onClose={onClose} style={{}} className="add-modal">
      <div className="add-modal-content">
        <h3>{title}</h3>
        <div className="add-name">
          <Button
            style={{ marginLeft: "15px" }}
            color="primary"
            onClick={onClose}
          >
            Dismiss
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default NotificationModal;
